import { render, staticRenderFns } from "./EmptyPrintPosition.vue?vue&type=template&id=6cb0836f&scoped=true"
import script from "./EmptyPrintPosition.vue?vue&type=script&lang=ts"
export * from "./EmptyPrintPosition.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./EmptyPrintPosition.vue?vue&type=style&index=0&id=6cb0836f&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6cb0836f",
  null
  ,true
)

export default component.exports